import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import VendorCreateContainer from "@legacy/vendors/VendorCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { VENDOR_ROUTES } from "@routes/vendor"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function VendorEdit() {
    const isDesktop = useIsDesktop()

    const vendorId = window.VENDOR_ID

    const [listRoute, detailsRoute] = useSlugExtractor([VENDOR_ROUTES.LIST, VENDOR_ROUTES.DETAILS], vendorId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const listBackDestination = hasPermission("vendors_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined
    const detailsBackDestination = hasPermission("vendors_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="VendorEdit">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Vendors"
                            icon={icon({ name: "store", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "store", style: "solid", family: "sharp" })}
                            destination={listBackDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Edit Vendor" backDestination={detailsBackDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <VendorCreateContainer formMode="EDIT_VENDOR" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
